import { AnalyticsReport } from 'store/analytics/ui/analyticsUiTypes';

// Reports types
export const TRANSACTION_DAILY_COUNTS = 'TRANSACTION_DAILY_COUNTS';
export const TRANSACTION_HITS_AND_MISSES = 'TRANSACTION_HITS_AND_MISSES';
export const MOCK_SERVICE_RESPONSE_TIME = 'MOCK_SERVICE_RESPONSE_TIME';
export const MOCK_SERVICE_TPS = 'MOCK_SERVICE_TPS';
export const MOCK_SERVICE_FORCED_DELAY = 'MOCK_SERVICE_FORCED_DELAY';
export const VSE_SERVER_AVAILABILITY = 'VSE_SERVER_AVAILABILITY';

export type ANALYTICS_REPORT_TYPE =
  | typeof TRANSACTION_DAILY_COUNTS
  | typeof TRANSACTION_HITS_AND_MISSES
  | typeof MOCK_SERVICE_RESPONSE_TIME
  | typeof MOCK_SERVICE_TPS
  | typeof MOCK_SERVICE_FORCED_DELAY
  | typeof VSE_SERVER_AVAILABILITY;

export const REPORT_TRANSACTION_DAILY_COUNTS: AnalyticsReport = {
  id: TRANSACTION_DAILY_COUNTS,
  name: 'Transaction Daily Counts',
  slug: 'transaction-daily-counts',
};

export const REPORT_TRANSACTION_HITS_AND_MISSES: AnalyticsReport = {
  id: TRANSACTION_HITS_AND_MISSES,
  name: 'Transaction Hits and Misses',
  slug: 'transaction-hits-and-misses',
};

export const REPORT_MOCK_SERVICE_RESPONSE_TIME: AnalyticsReport = {
  id: MOCK_SERVICE_RESPONSE_TIME,
  name: 'Virtual Service Response Time',
  slug: 'mock-service-response-time',
};

export const REPORT_MOCK_SERVICE_TPS: AnalyticsReport = {
  id: MOCK_SERVICE_TPS,
  name: 'Virtual Service Transactions per Second',
  slug: 'mock-service-tps',
};

/**
 * Hardcoded list of all available reports.
 */
export const analyticsReportTypes: AnalyticsReport[] = [
  REPORT_TRANSACTION_DAILY_COUNTS,
  REPORT_TRANSACTION_HITS_AND_MISSES,
  REPORT_MOCK_SERVICE_RESPONSE_TIME,
  REPORT_MOCK_SERVICE_TPS,
];
